<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    tone: 'warning' | 'danger';
    children: Snippet;
  }

  let { tone, children }: Props = $props();
</script>

<p class="notice" data-tone={tone} role="alert">{@render children()}</p>

<style>
  .notice {
    margin: 0;
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius-sm);
    font-size: 13px;
  }
  [data-tone='warning'] {
    background: var(--color-warning-bg);
    border: 1px solid var(--color-warning-border);
    color: var(--color-warning);
  }
  [data-tone='danger'] {
    background: var(--color-danger-bg);
    border: 1px solid var(--color-danger-border);
    color: var(--color-danger);
  }
</style>
